/* PIA_LANDING_PET_MOBILE_LIGHTBOX_SWIPE_20260824 */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.touchZoom = {
          image: null,
          gesture: null,
          scale: 1,
          x: 0,
          y: 0,
          startScale: 1,
          startX: 0,
          startY: 0,
          startDistance: 0,
          startTouchX: 0,
          startTouchY: 0,
          currentTouchX: 0,
          currentTouchY: 0,
        };

        this.zoomContent = this.querySelector('.product-media-modal__content');
        if (this.zoomContent) {
          this.zoomContent.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
          this.zoomContent.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
          this.zoomContent.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: false });
          this.zoomContent.addEventListener('touchcancel', this.handleTouchEnd.bind(this), { passive: false });
        }
      }

      isMobileFitLightbox() {
        return this.classList.contains('product-media-modal--landing-pet') && window.matchMedia('(max-width: 749px)').matches;
      }

      resetTouchZoom() {
        this.querySelectorAll('.product-media-modal__content > img').forEach((image) => {
          image.style.removeProperty('transform');
          image.classList.remove('is-touch-zoomed', 'is-swipe-dragging');
        });
        this.touchZoom.image = null;
        this.touchZoom.gesture = null;
        this.touchZoom.scale = 1;
        this.touchZoom.x = 0;
        this.touchZoom.y = 0;
        this.touchZoom.startDistance = 0;
        this.touchZoom.startTouchX = 0;
        this.touchZoom.startTouchY = 0;
        this.touchZoom.currentTouchX = 0;
        this.touchZoom.currentTouchY = 0;
        if (this.zoomContent) {
          this.zoomContent.scrollLeft = 0;
          this.zoomContent.scrollTop = 0;
        }
      }

      touchDistance(touches) {
        return Math.hypot(touches[1].clientX - touches[0].clientX, touches[1].clientY - touches[0].clientY);
      }

      clampPan(image) {
        const scaledWidth = image.offsetWidth * this.touchZoom.scale;
        const scaledHeight = image.offsetHeight * this.touchZoom.scale;
        const maxX = Math.max(0, (scaledWidth - this.zoomContent.clientWidth) / 2);
        const maxY = Math.max(0, (scaledHeight - this.zoomContent.clientHeight) / 2);
        this.touchZoom.x = Math.max(-maxX, Math.min(maxX, this.touchZoom.x));
        this.touchZoom.y = Math.max(-maxY, Math.min(maxY, this.touchZoom.y));
      }

      applyTouchZoom(image) {
        this.clampPan(image);
        image.style.transform = `translate3d(${this.touchZoom.x}px, ${this.touchZoom.y}px, 0) scale(${this.touchZoom.scale})`;
        image.classList.toggle('is-touch-zoomed', this.touchZoom.scale > 1.01);
      }

      showAdjacentMedia(direction) {
        const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        const activeIndex = mediaItems.findIndex((media) => media.classList.contains('active'));
        const nextIndex = activeIndex + direction;
        if (activeIndex < 0 || nextIndex < 0 || nextIndex >= mediaItems.length) {
          this.resetTouchZoom();
          return false;
        }

        const nextMedia = mediaItems[nextIndex];
        this.resetTouchZoom();
        mediaItems.forEach((media) => media.classList.remove('active'));
        nextMedia.classList.add('active');
        nextMedia.scrollIntoView({ block: 'center', inline: 'center' });
        this.zoomContent.scrollLeft = 0;
        this.zoomContent.scrollTop = 0;

        const mediaId = nextMedia.getAttribute('data-media-id');
        const opener = document.querySelector(`.product__media-toggle[data-media-id="${CSS.escape(mediaId)}"]`);
        if (opener) this.openedBy = opener;

        if (nextMedia.nodeName === 'DEFERRED-MEDIA') nextMedia.loadContent();
        return true;
      }

      handleTouchStart(event) {
        if (!this.isMobileFitLightbox()) return;
        const image = this.querySelector('.product-media-modal__content > img.active');
        if (!image || !(event.target instanceof Element) || !event.target.closest('img.active')) return;
        this.touchZoom.image = image;

        if (event.touches.length === 2) {
          event.preventDefault();
          this.touchZoom.gesture = 'pinch';
          this.touchZoom.startDistance = this.touchDistance(event.touches);
          this.touchZoom.startScale = this.touchZoom.scale;
          this.touchZoom.startX = this.touchZoom.x;
          this.touchZoom.startY = this.touchZoom.y;
          return;
        }

        if (event.touches.length === 1) {
          this.touchZoom.gesture = this.touchZoom.scale > 1.01 ? 'pan' : 'swipe';
          this.touchZoom.startTouchX = event.touches[0].clientX;
          this.touchZoom.startTouchY = event.touches[0].clientY;
          this.touchZoom.currentTouchX = event.touches[0].clientX;
          this.touchZoom.currentTouchY = event.touches[0].clientY;
          this.touchZoom.startX = this.touchZoom.x;
          this.touchZoom.startY = this.touchZoom.y;
        }
      }

      handleTouchMove(event) {
        if (!this.isMobileFitLightbox() || !this.touchZoom.image) return;

        if (event.touches.length === 2 && this.touchZoom.gesture === 'pinch' && this.touchZoom.startDistance > 0) {
          event.preventDefault();
          const nextScale = this.touchZoom.startScale * (this.touchDistance(event.touches) / this.touchZoom.startDistance);
          this.touchZoom.scale = Math.max(1, Math.min(4, nextScale));
          this.applyTouchZoom(this.touchZoom.image);
          return;
        }

        if (event.touches.length !== 1) return;
        this.touchZoom.currentTouchX = event.touches[0].clientX;
        this.touchZoom.currentTouchY = event.touches[0].clientY;

        if (this.touchZoom.gesture === 'pan' && this.touchZoom.scale > 1.01) {
          event.preventDefault();
          this.touchZoom.x = this.touchZoom.startX + this.touchZoom.currentTouchX - this.touchZoom.startTouchX;
          this.touchZoom.y = this.touchZoom.startY + this.touchZoom.currentTouchY - this.touchZoom.startTouchY;
          this.applyTouchZoom(this.touchZoom.image);
          return;
        }

        if (this.touchZoom.gesture === 'swipe') {
          const deltaX = this.touchZoom.currentTouchX - this.touchZoom.startTouchX;
          const deltaY = this.touchZoom.currentTouchY - this.touchZoom.startTouchY;
          if (Math.abs(deltaX) > 6 && Math.abs(deltaX) > Math.abs(deltaY)) {
            event.preventDefault();
            const dragX = Math.max(-80, Math.min(80, deltaX * 0.35));
            this.touchZoom.image.style.transform = `translate3d(${dragX}px, 0, 0)`;
            this.touchZoom.image.classList.add('is-swipe-dragging');
          }
        }
      }

      handleTouchEnd(event) {
        if (!this.isMobileFitLightbox() || !this.touchZoom.image) return;

        if (this.touchZoom.gesture === 'pinch') {
          if (this.touchZoom.scale <= 1.01) {
            this.resetTouchZoom();
          } else if (event.touches.length === 1) {
            this.touchZoom.gesture = 'pan';
            this.touchZoom.startTouchX = event.touches[0].clientX;
            this.touchZoom.startTouchY = event.touches[0].clientY;
            this.touchZoom.startX = this.touchZoom.x;
            this.touchZoom.startY = this.touchZoom.y;
          } else {
            this.touchZoom.gesture = null;
          }
          return;
        }

        if (this.touchZoom.gesture === 'swipe') {
          const changedTouch = event.changedTouches[0];
          const endX = changedTouch ? changedTouch.clientX : this.touchZoom.currentTouchX;
          const endY = changedTouch ? changedTouch.clientY : this.touchZoom.currentTouchY;
          const deltaX = endX - this.touchZoom.startTouchX;
          const deltaY = endY - this.touchZoom.startTouchY;
          const threshold = Math.min(90, Math.max(48, this.zoomContent.clientWidth * 0.16));
          const shouldChange = Math.abs(deltaX) >= threshold && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;
          this.touchZoom.image.style.removeProperty('transform');
          this.touchZoom.image.classList.remove('is-swipe-dragging');
          if (shouldChange) {
            this.showAdjacentMedia(deltaX < 0 ? 1 : -1);
          } else {
            this.resetTouchZoom();
          }
          return;
        }

        if (this.touchZoom.scale <= 1.01) this.resetTouchZoom();
      }

      hide() {
        this.resetTouchZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.resetTouchZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (this.isMobileFitLightbox()) {
          activeMedia.scrollIntoView({ block: 'center', inline: 'center' });
          this.zoomContent.scrollLeft = 0;
          this.zoomContent.scrollTop = 0;
        } else {
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
